module.exports = __webpack_public_path__ + "46fdc5c10ff3d48301684f20d345473e.png";